
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.328 9.047c0 .349.01.604.031.765.026.162.065.29.118.383a.697.697 0 00.242.235c.11.062.284.125.523.187V11H.945v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.945.72V.336h3.297v.383c-.229.057-.396.114-.5.172a.754.754 0 00-.242.218c-.057.084-.102.211-.133.383-.026.172-.039.438-.039.797v6.758z","fill":"currentColor"}})])
          )
        }
      }
    